import { useNavigate } from 'react-router-dom';
import CryptoJS from 'crypto-js';

// 加密后的 SECRET_KEY（使用登录密码加密）
const ENCRYPTED_SECRET_KEY = 'U2FsdGVkX19PNicy75wh9k7lfLIwmPbgHFqLMhuHxvy6/XRzbsFX5Ed5Cf0ERhQaq5RsNSypffjl8YhDjJLUaA==';

export const useAuth = () => {
    const navigate = useNavigate();

    const login = (password) => {
        try {
            // 尝试使用输入的密码解密 SECRET_KEY
            const decryptedSecretKey = CryptoJS.AES.decrypt(ENCRYPTED_SECRET_KEY, password).toString(CryptoJS.enc.Utf8);
            
            // 如果解密成功且结果不为空，说明密码正确
            if (decryptedSecretKey && decryptedSecretKey.length > 0) {
                localStorage.setItem('isAuthenticated', 'true');
                // 将解密后的 SECRET_KEY 存储到 localStorage
                localStorage.setItem('secretKey', decryptedSecretKey);
                return true;
            }
            return false;
        } catch (error) {
            // 解密失败，密码错误
            console.error('解密失败:', error);
            return false;
        }
    };

    const logout = () => {
        localStorage.removeItem('isAuthenticated');
        localStorage.removeItem('secretKey');
        navigate('/login');
    };

    const isAuthenticated = () => {
        return localStorage.getItem('isAuthenticated') === 'true';
    };

    return { login, logout, isAuthenticated };
};